import React from 'react'
import { useSelector } from 'react-redux'

function RightArrow() {
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <g opacity="0.3">
        <path d="M7.5 9.5L4.5 6.5L7.5 3.5" stroke="var(--theme-mode-color-white-reverse)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
    
  )
}

export default RightArrow